<div class="col-12 text-center mb-4">
  <h3 class="text-primary mb-3" style="text-align: left;">
    {{ title }}
  </h3>
  <div class="table-responsive">
    <table class="table table-striped table-hover table-bordered">
      <thead>
        <tr>

          <th scope="col" class="bg-danger text-white small">
            Tienda
          </th>

          <th scope="col" class="bg-danger text-white small">
            Total
          </th>

          @for(column of meter.columns; track column) {

          <th scope="col" class="bg-danger text-white small">
            {{ column }}
          </th>

          }

          @if (showMeta) {
          <th scope="col" class="bg-danger text-white small">Meta</th>
          }

        </tr>
      </thead>
      <tbody>
        @for (row of meter.data; track row) {
        <tr>
          <td class="small" style="text-align: left;">{{ row.tienda }}</td>
          <td class="small" style="text-align: right;">{{ row.total }}</td>

          @for (keyValue of row | keyvalue; track keyValue.key) {

          @if(keyValue.key.includes('dia') || keyValue.key.includes('semana')) {
          <td class="small" style="text-align: right;">
            {{ keyValue.value }}
          </td>
          }

          }

          @if (showMeta) {
          <td class="small text-end">{{ row.meta | percent }}</td>
          }

        </tr>
        } @empty {
        <tr>
          <td [colSpan]="colSpan" style="text-align: center">
            No hay datos recuperados
          </td>
        </tr>
        }
      </tbody>
    </table>

  </div>
</div>
